﻿package br.com.htms.inspeccaocampo.ui.screens

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.HorizontalDivider
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.OutlinedButton
import androidx.compose.material3.OutlinedTextField
import androidx.compose.material3.Switch
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import br.com.htms.inspeccaocampo.auth.AuthApi
import br.com.htms.inspeccaocampo.data.ObraItem
import br.com.htms.inspeccaocampo.form.AppController
import br.com.htms.inspeccaocampo.shared.ui.components.FormFieldDefaults
import kotlinx.coroutines.launch

@Composable
fun SharedAdminObrasPanel(
    controller: AppController,
    onMessage: (String) -> Unit
) {
    var obras by remember { mutableStateOf<List<ObraItem>>(emptyList()) }
    var loading by remember { mutableStateOf(true) }
    var novaObra by remember { mutableStateOf("") }
    var filtro by remember { mutableStateOf("") }
    var catalogoAberto by remember { mutableStateOf(false) }
    var editandoId by remember { mutableStateOf<String?>(null) }
    var editNome by remember { mutableStateOf("") }
    val scope = rememberCoroutineScope()

    fun recarregar() {
        scope.launch {
            loading = true
            AuthApi.listObrasAdmin()
                .onSuccess { obras = it.sortedWith(compareBy({ !it.ativo }, { it.sortOrder }, { it.nome })) }
                .onFailure { onMessage(it.message ?: "Falha ao listar obras") }
            loading = false
        }
    }

    LaunchedEffect(Unit) { recarregar() }

    val filtradas = remember(obras, filtro) {
        val q = filtro.trim()
        if (q.isEmpty()) obras
        else obras.filter { it.nome.contains(q, ignoreCase = true) }
    }

    val compactBtnPadding = PaddingValues(horizontal = 8.dp, vertical = 4.dp)

    Card(
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surfaceVariant),
        modifier = Modifier.fillMaxWidth()
    ) {
        Column(
            Modifier.padding(horizontal = 8.dp, vertical = 6.dp),
            verticalArrangement = Arrangement.spacedBy(4.dp)
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(Modifier.weight(1f)) {
                    Text(
                        "Catálogo de obras",
                        fontWeight = FontWeight.Bold,
                        style = MaterialTheme.typography.titleSmall
                    )
                    Text(
                        if (catalogoAberto) {
                            "Somente admin. Ativas no dropdown do formulário."
                        } else {
                            "Oculto. Toque em Abrir para gerenciar."
                        },
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }
                OutlinedButton(
                    onClick = { catalogoAberto = !catalogoAberto },
                    contentPadding = compactBtnPadding
                ) {
                    Text(if (catalogoAberto) "Ocultar" else "Abrir", style = MaterialTheme.typography.labelLarge)
                }
            }

            if (!catalogoAberto) return@Column

            if (loading) {
                Text("Carregando…", style = MaterialTheme.typography.labelSmall)
            }

            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.spacedBy(6.dp),
                verticalAlignment = Alignment.CenterVertically
            ) {
                OutlinedTextField(
                    value = novaObra,
                    onValueChange = { novaObra = it },
                    placeholder = { Text("Nova obra", style = MaterialTheme.typography.bodySmall) },
                    singleLine = true,
                    textStyle = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.weight(1f),
                    colors = FormFieldDefaults.textFieldColors()
                )
                OutlinedButton(
                    onClick = {
                        val nome = novaObra.trim()
                        if (nome.isBlank()) {
                            onMessage("Informe o nome da obra.")
                            return@OutlinedButton
                        }
                        scope.launch {
                            AuthApi.createObra(nome)
                                .onSuccess {
                                    novaObra = ""
                                    onMessage("Obra adicionada.")
                                    recarregar()
                                    controller.carregarObrasAtivas()
                                }
                                .onFailure { onMessage(it.message ?: "Falha ao adicionar obra") }
                        }
                    },
                    enabled = novaObra.isNotBlank(),
                    contentPadding = compactBtnPadding
                ) { Text("Adicionar", style = MaterialTheme.typography.labelLarge) }
            }

            if (obras.size > 5) {
                OutlinedTextField(
                    value = filtro,
                    onValueChange = { filtro = it },
                    placeholder = { Text("Buscar obra", style = MaterialTheme.typography.bodySmall) },
                    singleLine = true,
                    textStyle = MaterialTheme.typography.bodySmall,
                    modifier = Modifier.fillMaxWidth(),
                    colors = FormFieldDefaults.textFieldColors()
                )
            }

            filtradas.forEachIndexed { index, obra ->
                if (index > 0) {
                    HorizontalDivider(color = MaterialTheme.colorScheme.outlineVariant)
                }
                val emEdicao = editandoId == obra.id
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .padding(vertical = 2.dp),
                    horizontalArrangement = Arrangement.spacedBy(4.dp),
                    verticalAlignment = Alignment.CenterVertically
                ) {
                    if (emEdicao) {
                        OutlinedTextField(
                            value = editNome,
                            onValueChange = { editNome = it },
                            placeholder = { Text("Nome", style = MaterialTheme.typography.bodySmall) },
                            singleLine = true,
                            textStyle = MaterialTheme.typography.bodySmall,
                            modifier = Modifier.weight(1f),
                            colors = FormFieldDefaults.textFieldColors()
                        )
                        TextButton(
                            onClick = {
                                val nome = editNome.trim()
                                if (nome.length < 2) {
                                    onMessage("Nome da obra inválido.")
                                    return@TextButton
                                }
                                scope.launch {
                                    AuthApi.updateObra(obra.id, nome = nome)
                                        .onSuccess {
                                            editandoId = null
                                            editNome = ""
                                            onMessage("Nome atualizado.")
                                            recarregar()
                                            controller.carregarObrasAtivas()
                                        }
                                        .onFailure {
                                            onMessage(it.message ?: "Falha ao renomear obra")
                                        }
                                }
                            },
                            contentPadding = compactBtnPadding
                        ) { Text("Salvar", style = MaterialTheme.typography.labelMedium) }
                        TextButton(
                            onClick = {
                                editandoId = null
                                editNome = ""
                            },
                            contentPadding = compactBtnPadding
                        ) { Text("Cancelar", style = MaterialTheme.typography.labelMedium) }
                    } else {
                        Text(
                            obra.nome,
                            modifier = Modifier.weight(1f),
                            style = MaterialTheme.typography.bodySmall,
                            maxLines = 1,
                            overflow = TextOverflow.Ellipsis
                        )
                        TextButton(
                            onClick = {
                                editandoId = obra.id
                                editNome = obra.nome
                            },
                            contentPadding = compactBtnPadding
                        ) { Text("Editar", style = MaterialTheme.typography.labelMedium) }
                    }
                    Text(
                        if (obra.ativo) "Ativa" else "Inativa",
                        style = MaterialTheme.typography.labelSmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                    Switch(
                        checked = obra.ativo,
                        onCheckedChange = { ativo ->
                            scope.launch {
                                AuthApi.updateObra(obra.id, ativo = ativo)
                                    .onSuccess {
                                        recarregar()
                                        controller.carregarObrasAtivas()
                                    }
                                    .onFailure {
                                        onMessage(it.message ?: "Falha ao atualizar obra")
                                    }
                            }
                        }
                    )
                }
            }

            if (!loading && filtradas.isEmpty()) {
                Text(
                    if (filtro.isNotBlank()) "Nenhuma obra encontrada." else "Nenhuma obra cadastrada.",
                    style = MaterialTheme.typography.labelSmall,
                    color = MaterialTheme.colorScheme.onSurfaceVariant
                )
            }
        }
    }
}
